import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_weeks_food_bar_with_last_week_and_year_variables = {
	id: "REPORT_weeks_food_bar_with_last_week_and_year_variables",
	name: "Raport tygodniowy z porównaniem poprzedniego tygodnia i danego roku",
	variables: [
		{
			id: "food_organization_ids",
		},
		{
			id: "bar_organization_ids",
		},
		{
			id: "date_range",
			type: "WEEK",
		},
		{
			id: "date_range_last_year_week",
			type: "DYNAMIC",
			calculate: {
				variable_id: "date_range",
				method: "previous_week_by_years",
				value: 1,
			},
		},
		{
			id: "date_range_this_year",
			type: "DYNAMIC",
			calculate: {
				variable_id: "date_range",
				method: "previous_year_to_date",
				value: 0,
			},
		},
		{
			id: "date_range_previous_year",
			type: "DYNAMIC",
			calculate: {
				variable_id: "date_range",
				method: "previous_year_to_date",
				value: 1,
			},
		},
		{
			id: "date_range_this_month",
			type: "DYNAMIC",
			calculate: {
				variable_id: "date_range",
				method: "previous_month_to_date",
				value: 0,
			},
		},
		{
			id: "date_range_previous_month",
			type: "DYNAMIC",
			calculate: {
				variable_id: "date_range",
				method: "previous_month_to_date",
				value: 12,
			},
		},
	],
	data: [
		{
			id: "BILLS",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={food_organization_ids}",
			groups: ["NONE", "ORGANIZATION"],
			columns: [
				{
					id: "summary",
					filter: "date_range|bt={date_range}",
				},
			],
		},
		{
			id: "BILLS_LYW",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={food_organization_ids}",
			groups: ["NONE", "ORGANIZATION"],
			columns: [
				{
					id: "summary_lyw",
					filter: "date_range|bt={date_range_last_year_week}",
				},
			],
		},
		{
			id: "BILLS_TM",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={food_organization_ids}",
			groups: ["NONE", "ORGANIZATION"],
			columns: [
				{
					id: "summary_tm",
					filter: "date_range|bt={date_range_this_month}",
				},
			],
		},
		{
			id: "BILLS_LM",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={food_organization_ids}",
			groups: ["NONE", "ORGANIZATION"],
			columns: [
				{
					id: "summary_lm",
					filter: "date_range|bt={date_range_previous_month}",
				},
			],
		},
		{
			id: "BILLS_TY",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={food_organization_ids}",
			groups: ["NONE", "ORGANIZATION"],
			columns: [
				{
					id: "summary_ty",
					filter: "date_range|bt={date_range_this_year}",
				},
			],
		},
		{
			id: "BILLS_LY",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={food_organization_ids}",
			groups: ["NONE", "ORGANIZATION"],
			columns: [
				{
					id: "summary_ly",
					filter: "date_range|bt={date_range_previous_year}",
				},
			],
		},
		{
			id: "BILLS_BAR",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={bar_organization_ids}",
			groups: ["NONE", "ORGANIZATION", "POINT_OF_SALE"],
			columns: [
				{
					id: "summary",
					filter: "date_range|bt={date_range}",
				},
			],
		},
		{
			id: "BILLS_BAR_LYW",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={bar_organization_ids}",
			groups: ["NONE", "ORGANIZATION", "POINT_OF_SALE"],
			columns: [
				{
					id: "summary_lyw",
					filter: "date_range|bt={date_range_last_year_week}",
				},
			],
		},
		{
			id: "BILLS_BAR_TM",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={bar_organization_ids}",
			groups: ["NONE", "ORGANIZATION", "POINT_OF_SALE"],
			columns: [
				{
					id: "summary_tm",
					filter: "date_range|bt={date_range_this_month}",
				},
			],
		},
		{
			id: "BILLS_BAR_LM",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={bar_organization_ids}",
			groups: ["NONE", "ORGANIZATION", "POINT_OF_SALE"],
			columns: [
				{
					id: "summary_lm",
					filter: "date_range|bt={date_range_previous_month}",
				},
			],
		},
		{
			id: "BILLS_BAR_TY",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={bar_organization_ids}",
			groups: ["NONE", "ORGANIZATION", "POINT_OF_SALE"],
			columns: [
				{
					id: "summary_ty",
					filter: "date_range|bt={date_range_this_year}",
				},
			],
		},
		{
			id: "BILLS_BAR_LY",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={bar_organization_ids}",
			groups: ["NONE", "ORGANIZATION", "POINT_OF_SALE"],
			columns: [
				{
					id: "summary_ly",
					filter: "date_range|bt={date_range_previous_year}",
				},
			],
		},
	],
	table: [
		{
			id: "table2",
			rows: [
				{
					id: "food",
					type: "CALCULATE",
					data_ids: ["BILLS", "BILLS_LYW", "BILLS_TM", "BILLS_LM", "BILLS_TY", "BILLS_LY", "BILLS_LW"],
					group: "ORGANIZATION",
					name: "Food",
					aggregate_columns: {
						transaction_count: "BILLS.transaction_count",
						average_net_money: "BILLS.average_net_money",
						net_total_money: "BILLS.net_total_money",
						lyw_net_total_money: "BILLS_LYW.net_total_money",
						this_week_vs_last_year_week: "((BILLS.net_total_money / BILLS_LYW.net_total_money) - 1) * 100",
						this_month_net_total_money: "BILLS_TM.net_total_money",
						last_year_month_net_total_money: "BILLS_LM.net_total_money",
						this_month_vs_last_year_month:
							"((BILLS_TM.net_total_money / BILLS_LM.net_total_money) - 1) * 100",
						this_year_net_total_money: "BILLS_TY.net_total_money",
						last_year_net_total_money: "BILLS_LY.net_total_money",
						this_year_vs_last_year: "((BILLS_TY.net_total_money / BILLS_LY.net_total_money) - 1) * 100",
					},
				},
				{
					id: "bar",
					type: "CALCULATE",
					data_ids: [
						"BILLS_BAR",
						"BILLS_BAR_LYW",
						"BILLS_BAR_TM",
						"BILLS_BAR_LM",
						"BILLS_BAR_TY",
						"BILLS_BAR_LY",
						"BILLS_BAR_LW",
					],
					group: "POINT_OF_SALE",
					name: "Bar",
					aggregate_columns: {
						transaction_count: "BILLS_BAR.transaction_count",
						average_net_money: "BILLS_BAR.average_net_money",
						net_total_money: "BILLS_BAR.net_total_money",
						lyw_net_total_money: "BILLS_BAR_LYW.net_total_money",
						this_week_vs_last_year_week:
							"((BILLS_BAR.net_total_money / BILLS_BAR_LYW.net_total_money) - 1) * 100",
						this_month_net_total_money: "BILLS_BAR_TM.net_total_money",
						last_year_month_net_total_money: "BILLS_BAR_LM.net_total_money",
						this_month_vs_last_year_month:
							"((BILLS_BAR_TM.net_total_money / BILLS_BAR_LM.net_total_money) - 1) * 100",
						this_year_net_total_money: "BILLS_BAR_TY.net_total_money",
						last_year_net_total_money: "BILLS_BAR_LY.net_total_money",
						this_year_vs_last_year:
							"((BILLS_BAR_TY.net_total_money / BILLS_BAR_LY.net_total_money) - 1) * 100",
					},
				},
				{
					id: "total",
					type: "CALCULATE",
					name: "Total",
					aggregate_columns: {
						transaction_count: "BILLS.transaction_count + BILLS_BAR.transaction_count",
						average_net_money:
							"(BILLS.net_total_money + BILLS_BAR.net_total_money) / (BILLS.transaction_count + BILLS_BAR.transaction_count)",
						net_total_money: "BILLS.net_total_money + BILLS_BAR.net_total_money",
						lyw_net_total_money: "BILLS_LYW.net_total_money + BILLS_BAR_LYW.net_total_money",
						this_week_vs_last_year_week:
							"(((BILLS.net_total_money + BILLS_BAR.net_total_money) / (BILLS_LYW.net_total_money + BILLS_BAR_LYW.net_total_money)) - 1) * 100",
						this_month_net_total_money: "BILLS_TM.net_total_money + BILLS_BAR_TM.net_total_money",
						last_year_month_net_total_money: "BILLS_LM.net_total_money + BILLS_BAR_LM.net_total_money",
						this_month_vs_last_year_month:
							"(((BILLS_TM.net_total_money + BILLS_BAR_TM.net_total_money) / (BILLS_LM.net_total_money + BILLS_BAR_LM.net_total_money)) - 1) * 100",
						this_year_net_total_money: "BILLS_TY.net_total_money + BILLS_BAR_TY.net_total_money",
						last_year_net_total_money: "BILLS_LY.net_total_money + BILLS_BAR_LY.net_total_money",
						this_year_vs_last_year:
							"(((BILLS_TY.net_total_money + BILLS_BAR_TY.net_total_money) / (BILLS_LY.net_total_money + BILLS_BAR_LY.net_total_money)) - 1) * 100",
					},
				},
			],
			columns: [
				{
					id: "net_total_money",
					data_column_id: "summary",
					name: "Net this week",
					custom_format: {
						precision: 0,
						locale: "pl-PL",
					},
				},
				{
					id: "transaction_count",
					data_column_id: "summary",
					name: "Nr. of bills",
					custom_format: {
						precision: 0,
						locale: "pl-PL",
					},
				},
				{
					id: "average_net_money",
					name: "Av. Bill val",
					custom_format: {
						precision: 0,
						locale: "pl-PL",
					},
				},
				{
					id: "lyw_net_total_money",
					data_column_id: "summary_lyw",
					name: "Net same week last year",
					custom_format: {
						precision: 0,
						locale: "pl-PL",
					},
				},
				{
					id: "this_week_vs_last_year_week",
					name: "Net this week vs same week last year",
					// "data_column_id": "summary",
					format: "PERCENT",
					custom_format: {
						precision: 0,
						locale: "pl-PL",
					},
					styles: {
						percent_color: true,
					},
				},
				{
					id: "this_month_net_total_money",
					data_column_id: "summary_tm",
					name: "Net this month",
					custom_format: {
						precision: 0,
						locale: "pl-PL",
					},
				},
				{
					id: "last_year_month_net_total_money",
					data_column_id: "summary_lm",
					name: "Net same month last year",
					custom_format: {
						precision: 0,
						locale: "pl-PL",
					},
				},
				{
					id: "this_month_vs_last_year_month",
					name: "Net this month vs same month last year",
					format: "PERCENT",
					custom_format: {
						precision: 0,
						locale: "pl-PL",
					},
					styles: {
						percent_color: true,
					},
				},
				{
					id: "this_year_net_total_money",
					data_column_id: "summary_ty",
					name: "Net YTD",
					custom_format: {
						precision: 0,
						locale: "pl-PL",
					},
				},
				{
					id: "last_year_net_total_money",
					data_column_id: "summary_ly",
					name: "Net last year for the same period",
					custom_format: {
						precision: 0,
						locale: "pl-PL",
					},
				},
				{
					id: "this_year_vs_last_year",
					name: "Net YTD vs same period last year",
					format: "PERCENT",
					styles: {
						percent_color: true,
					},
				},
			],
		},
	],
} as ConfigReportComboApi;
